import { jobPostingRecommendationsVar } from '../../cache/learner/jobPostingRecommendationsReactiveVar';
import { IJobPostingRecommendation } from '../../operations/query/students/useGetJobPostingRecommendations/useGetJobPostingRecomendations';
import { decryptor, encryptor } from '../../utils/decryptor';

export interface IJobPostingRecommendationHook {
  operations: {
    setJobPostingRecommendations: (jobPostingRecommendations: IJobPostingRecommendation[]) => void;
    setFromLocalJobPostingRecommendations: () => boolean;
  };
}

const useJobPostingRecomnmendationHook = (): IJobPostingRecommendationHook => {
  const setJobPostingRecommendations = (jobPostingRecommendations: IJobPostingRecommendation[]): void => {
    jobPostingRecommendationsVar({
      error: undefined,
      data: jobPostingRecommendations,
    });

    const encryptedData = encryptor(JSON.stringify(jobPostingRecommendations));

    if (!encryptedData) {
      return;
    }

    sessionStorage.setItem('jobPostingRecommendations', encryptedData);
  };

  const setFromLocalJobPostingRecommendations = (): boolean => {
    const storedJobPostingRecommendations = sessionStorage.getItem('jobPostingRecommendations');
    const decryptedData = decryptor(storedJobPostingRecommendations ?? '');

    if (!decryptedData) {
      return false;
    }
    jobPostingRecommendationsVar({
      error: undefined,
      data: JSON.parse(decryptedData),
    });

    return true;
  };

  return {
    operations: {
      setJobPostingRecommendations,
      setFromLocalJobPostingRecommendations,
    },
  };
};

export default useJobPostingRecomnmendationHook;
